import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getAllApts = () => {
  try {
    return axios.get(BASE_URL + "threats/getAllApts", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAptData = (apt) => {
  try {
    return axios.get(BASE_URL + "threats/getAptData?apt=" + apt, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAptPosts = (apt) => {
  try {
    return axios.get(BASE_URL + "threats/getPostsByApt?apt=" + apt, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const searchApts = ({ searchString, offset }) => {
  try {
    return axios.get(
      BASE_URL +
        "threats/searchApts?search=" +
        searchString +
        "&offset=" +
        offset,
      {
        headers: authHeader(),
      },
    );
  } catch (e) {
    console.log(e);
    return e;
  }
};
